import { useEffect } from "react"
import Faq from "../components/Faq"
import { Link } from "react-router-dom"
import { useTranslation } from "react-i18next"

const IMG = "/assets/img/teach"

const steps = [
  { title: "sign_up", desc: "step_1_desc" },
  { title: "get_approved", desc: "step_2_desc" },
  { title: "start_earning", desc: "step_3_desc" },
]

const benefits = [
  { icon: "fa-sack-dollar", title: "set_your_own_rate", desc: "set_your_own_rate_desc" },
  { icon: "fa-clock", title: "teach_anytime", desc: "teach_anytime_desc" },
  { icon: "fa-arrow-trend-up", title: "grow_professionally", desc: "grow_professionally_desc" },
]

const features = [
  "steady_stream",
  "smart_calendar",
  "interactive_classroom",
  "convenient_payment",
  "professional_webinars",
  "supportive_community",
]

export default function BecomeTeach(){
  const { t } = useTranslation();

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  const scrollToSteps = (e) => {
    e.preventDefault()
    document.getElementById("tp-steps")?.scrollIntoView({ behavior: "smooth" })
  }

  return (
    <main className="teach-page">
      {/* hero */}
      <section className="tp-hero">
        <div className="container">
          <div className="row align-items-center gy-5">
            <div className="col-lg-6">
              <span className="tp-eyebrow">
                <span className="tp-eyebrow-dot" /> {t("becomeTeach.eyebrow")}
              </span>
              <h1 className="tp-title">{t("becomeTeach.make_a_living")}</h1>
              <p className="tp-lead">{t("becomeTeach.hero_subtitle")}</p>
              <div className="tp-actions">
                <Link to="/signup-tutor" className="tp-btn tp-btn--primary">
                  {t("becomeTeach.create_profile_now")} <i className="fa-light fa-arrow-right" />
                </Link>
                <a href="#tp-steps" onClick={scrollToSteps} className="tp-btn tp-btn--ghost">
                  {t("becomeTeach.see_how")}
                </a>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="tp-visual">
                <div className="tp-photo tp-photo--main">
                  <img src={`${IMG}/teach-hero-tutor.jpg`} alt={t("becomeTeach.hero_tutor_alt")} fetchpriority="high" />
                </div>
                <div className="tp-photo tp-photo--side">
                  <img src={`${IMG}/teach-hero-side.jpg`} alt={t("becomeTeach.hero_side_alt")} />
                </div>

                <div className="tp-badge tp-badge--booking" aria-hidden="true">
                  <span className="tp-badge-icon tp-badge-icon--green"><i className="fa-solid fa-calendar-check" /></span>
                  <div>
                    <strong>{t("becomeTeach.badge_booking_title")}</strong>
                    <span>{t("becomeTeach.badge_booking_time")}</span>
                  </div>
                </div>
                <div className="tp-badge tp-badge--rate" aria-hidden="true">
                  <span className="tp-badge-icon tp-badge-icon--orange"><i className="fa-solid fa-sack-dollar" /></span>
                  <div>
                    <span>{t("becomeTeach.badge_rate_label")}</span>
                    <strong>{t("becomeTeach.badge_rate_value")}</strong>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 3 steps */}
      <section className="tp-steps" id="tp-steps">
        <div className="container">
          <h2 className="tp-section-title">{t("becomeTeach.steps_title")}</h2>
          <div className="row g-4">
            {steps.map((step, i) => (
              <div className="col-md-4" key={step.title}>
                <article className="tp-step-card">
                  <span className={`tp-step tp-step--${i + 1}`}>{i + 1}</span>
                  <h3>{t(`becomeTeach.${step.title}`)}</h3>
                  <p>{t(`becomeTeach.${step.desc}`)}</p>
                </article>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* benefits */}
      <section className="tp-benefits">
        <div className="container">
          <h2 className="tp-section-title">{t("becomeTeach.benefits_title")}</h2>
          <div className="row g-4">
            {benefits.map((item, i) => (
              <div className="col-md-4" key={item.title}>
                <article className="tp-benefit">
                  <span className={`tp-benefit-icon tp-benefit-icon--${i + 1}`}>
                    <i className={`fa-light ${item.icon}`} />
                  </span>
                  <h3>{t(`becomeTeach.${item.title}`)}</h3>
                  <p>{t(`becomeTeach.${item.desc}`)}</p>
                </article>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* worldwide reach + teaching tools */}
      <section className="tp-global">
        <div className="container">
          <div className="row align-items-center gy-5">
            <div className="col-lg-6">
              <div className="tp-global-media">
                <div className="tp-photo tp-photo--wide">
                  <img src={`${IMG}/teach-global.jpg`} alt={t("becomeTeach.global_alt")} loading="lazy" />
                </div>
                <div className="tp-badge tp-badge--live" aria-hidden="true">
                  <span className="tp-live-dot" /> {t("becomeTeach.interactive_classroom")}
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="tp-global-content">
                <h2 className="tp-section-title">{t("becomeTeach.teach_students_180")}</h2>
                <p className="tp-lead">{t("becomeTeach.xller_tutors_teach")}</p>
                <ul className="tp-features">
                  {features.map((key, i) => (
                    <li key={key}>
                      <span className={`tp-check tp-check--${(i % 3) + 1}`}><i className="fa-solid fa-check" /></span>
                      {t(`becomeTeach.${key}`)}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* testimonial */}
      <section className="tp-quote">
        <div className="container">
          <div className="tp-quote-card">
            <div className="row g-0 align-items-stretch">
              <div className="col-md-5">
                <img className="tp-quote-img" src={`${IMG}/teach-quote.jpg`} alt={t("becomeTeach.quote_alt")} loading="lazy" />
              </div>
              <div className="col-md-7">
                <div className="tp-quote-body">
                  <i className="fa-solid fa-quote-left tp-quote-mark" aria-hidden="true" />
                  <blockquote>{t("becomeTeach.testimonial_quote")}</blockquote>
                  <div className="tp-quote-author">
                    <strong>Krista A.</strong>
                    <span>{t("becomeTeach.english_tutor")}</span>
                  </div>
                  <Link to="/signup-tutor" className="tp-btn tp-btn--primary">
                    {t("becomeTeach.become_tutor_now")} <i className="fa-light fa-arrow-right" />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Faq />

      {/* closing CTA */}
      <section className="tp-cta">
        <div className="container">
          <div className="tp-cta-card">
            <div className="row g-0 align-items-stretch">
              <div className="col-lg-7">
                <div className="tp-cta-body">
                  <h2>{t("becomeTeach.get_paid_online")}</h2>
                  <p>{t("becomeTeach.connect_with_learners")}</p>
                  <Link to="/signup-tutor" className="tp-btn tp-btn--dark">
                    {t("becomeTeach.become_tutor_now")} <i className="fa-light fa-arrow-right" />
                  </Link>
                </div>
              </div>
              <div className="col-lg-5">
                <img className="tp-cta-img" src={`${IMG}/teach-cta.jpg`} alt={t("becomeTeach.cta_alt")} loading="lazy" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  )
}
